
import { useState } from "react";
import { toast } from "react-toastify";
import { ApiTypes, VALIDATION_MESSAGE } from "../constants/Constants";
import { POSTAPI , GETAPI , POSTAPIFORMDATA } from "../config/Api";

const useMakeRequest = () => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<any>(null);

    const makeRequest = async ({ payload = {}, url, type = ApiTypes?.POST, toastStatus = false }: {
        payload?: any,
        url: string,
        type?: string,
        toastStatus?: boolean,
    }) => {
        const loginTrace = typeof url === 'string' && url.includes('sign-in');
        const loginT0 =
            loginTrace && typeof performance !== 'undefined'
                ? performance.now()
                : loginTrace
                  ? Date.now()
                  : 0;
        const loginElapsed = () =>
            loginTrace
                ? Math.round(((typeof performance !== 'undefined' ? performance.now() : Date.now()) - loginT0) * 100) / 100
                : 0;
        try {
            setLoading(true);
            setStatus(false);
            setError(null);
            setData(null)

            const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL;

            if (loginTrace) {
                console.log('[Login][WEB FE] ApiHelper — API started (hook)', {
                    ms: 0,
                    url,
                    type,
                    payloadKeys: payload ? Object.keys(payload as object) : [],
                });
            }

            let data = null;
            if (type === ApiTypes?.GET) {
                data = await GETAPI(url, payload, toastStatus);
            } else if (type === ApiTypes?.POST) {
                data = await POSTAPI(url, payload, toastStatus);
            }
            else if (type === ApiTypes?.POSTAPIFORMDATA) {
                data = await POSTAPIFORMDATA(url, payload, toastStatus);
            }

            if (loginTrace) {
                console.log('[Login][WEB FE] ApiHelper — API running — POSTAPI returned', {
                    ms: loginElapsed(),
                    typeofData: typeof data,
                    isNull: data == null,
                    keys: data && typeof data === 'object' ? Object.keys(data as object) : [],
                    bodyStatus: (data as any)?.status,
                    bodyStatusType: typeof (data as any)?.status,
                    strictEqTrue: (data as any)?.status === true,
                    looseEqTrue: (data as any)?.status == true,
                    hasAccessToken: Boolean((data as any)?.access_token),
                    userId: (data as any)?.data?.id,
                });
            }

            if (data && data?.status == true) {
                if (loginTrace) {
                    console.log('[Login][WEB FE] ApiHelper — API ended — response set (success)', { ms: loginElapsed() });
                }
                setStatus(true);
                setLoading(false);
                setError(null);
                setData(data);
                return data;
            }
            if (loginTrace) {
                console.warn('[Login][WEB FE] ApiHelper — API ended — response set (not success)', {
                    ms: loginElapsed(),
                    reason: !data ? 'data is null/undefined' : 'data.status is not true',
                    serverMessage: (data as any)?.message,
                    serverStatusCode: (data as any)?.status_code,
                });
            }
            setStatus(false);
            setLoading(false);
            setError(data);
            setData(null);
            return data ?? null;

        } catch (error: any) {
            if (typeof url === 'string' && url.includes('sign-in')) {
                const ms =
                    loginTrace && loginT0
                        ? Math.round(((typeof performance !== 'undefined' ? performance.now() : Date.now()) - loginT0) * 100) / 100
                        : undefined;
                console.error('[Login][WEB FE] ApiHelper — API ended — exception', {
                    ms,
                    message: error?.message,
                    responseStatus: error?.response?.status,
                    responseData: error?.response?.data,
                });
            }
            if (toastStatus !== false) {
                toast.error(error?.response?.data?.message ?? VALIDATION_MESSAGE?.CATCH_ERROR);
            }
            setError(error);
            setStatus(false);
            setLoading(false);
            setData(null);
            throw error;
        }
    };

    const reset = () => {
        setLoading(false);
        setStatus(false);
        setError(null);
        setData(null)
    }
    return { loading, data, error, status, reset, makeRequest };
};

export default useMakeRequest;